<template>
 <div>
    <b-field class="commonrules-grp" label="Car vendor is not in the following list of preferred chains">
      <TagAutocomplete
        placeholder="e.g. Hertz"
        icon="magnify"
        :chainData="carVendors"
        :selected="carPreferredVendors"
        @list="getSelectedCarVendors()"
        ></TagAutocomplete>
    </b-field>
</div>
</template>

  <script>
  import TagAutocomplete from '../../Tags/TagAutocomplete.vue';

    export default {
      name: "CarPreferredVendors",
      components: {
        TagAutocomplete
      },
      data() {
        return {
          carPreferredVendors:[]
        }
      },
      computed:{
        carVendors(){
           return Object.entries(this.$store.state.bookTravel.vendors.carProviders);
        }
      },
      methods:{
        getSelectedCarVendors() {
          this.$emit('carPreferredVendors',this.carPreferredVendors)
        }
      },
    }
  </script>
